


































































































































































































































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import {
  IdentityProofingOptionType,
  IdentityOption,
  ThemeGetRequest,
  IdentityProofDataVerifyRequest,
  AccountVerificationType
} from "@/shared/types";
import { Validator } from "vee-validate";
import moment from "moment";
import { mergeReturnUrl } from "@/shared/loginNavigation";
import AlternateLoginCard from "@/shared/components/AlternateLoginCard.vue";
import ResendCodeCard from "@/shared/components/ResendCodeCard.vue";
import SupportCard from "@/shared/components/SupportCard.vue";
import Input from "@/shared/components/ui/Input.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import VerificationCode from "@/employee/components/shared/VerificationCode.vue";
import {
  identityProofingChallenge,
  identityProofingDataVerify,
  identityProofingVerify,
  mfaEmailChallenge,
  mfaEmailVerify
} from "@/shared/api/userService";
import { verifyHsabAccount } from "@/shared/api/bankService";
import { LoginRouteNames } from "@/shared/loginRoutes";
import _ from "lodash";
import { Config } from "@/shared/config";
import { isMobileApp } from "@/shared/mobileHelper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useCredentialFlowStore } from "@/employee/store/credentialFlow";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useThemeStore } from "@/shared/store/theme";

enum HsabClaimAccountStep {
  Verification = 0,
  VerifyIdentityProofingChallenge = 1,
  EditAccountInfo = 2,
  VerifyMfaEmail = 3
}

const HsabPartnerId = 15;

@Component({
  components: {
    Input,
    Checkbox,
    Button,
    RadioButton,
    LoginWrapper,
    GenericLoadingSpinner,
    SupportCard,
    AlternateLoginCard,
    ResendCodeCard,
    VerificationCode,
  }
})
export default class HsabClaimAccount extends Vue {
  $validator: Validator;
  notifierStore = useNotifierStore();

  credentialFlowStore = useCredentialFlowStore();
  portalCustomizationStore = usePortalCustomizationStore();
  themeStore = useThemeStore();

  ssn = "";
  dateOfBirth = "";
  zipCode = "";

  firstName = "";
  lastName = "";
  oldHomePhone = "";
  newHomePhone = "";
  oldMobilePhone = "";
  newMobilePhone = "";
  oldEmail = "";
  newEmail = "";
  verificationCode = "";
  signature = "";
  accountNumber = "";
  cardLastFourDigits = "";

  isSubmitting = false;
  hasProofingOptions = false;
  hasMultipleProofingOptions = false;
  challengeType: IdentityProofingOptionType;
  verifyAccountWithAccountNumber = true;
  showSkipMfaEmailVerifyStep = false;

  @Prop()
  routeToClaimAccountVerify;

  @Prop()
  dateOfBirthProp?: string;

  @Prop()
  zipCodeProp?: string;

  mounted () {
    if (!this.credentialFlowStore.credentialFlowUsername) {
      this.$router.push({ name: LoginRouteNames.OktaLogin });
    }

    let partnerId = (this.portalCustomizationStore.partnerId || HsabPartnerId);

    // mobile.partnerid is set from the bitrise build for each partner specific app
    if (Config.Mobile.PartnerId && Number(Config.Mobile.PartnerId) > 0) {
      partnerId = Config.Mobile.PartnerId as any;
    }

    const parsedPartnerId = _.toSafeInteger(partnerId) || HsabPartnerId;

    this.credentialFlowStore.resetIdentityOptionsFetchState();
    this.themeStore.getTheme({ partnerId: parsedPartnerId, employerId: 0, forceUpdate: true });
    this.credentialFlowStore.loadIdentityOptions(this.credentialFlowStore.credentialFlowUsername).then(() => {
      this.hasProofingOptions = this.credentialFlowStore.identityOptions.length > 0;
      if (this.hasProofingOptions) {
        this.credentialFlowStore.setSelectedIdentityOption(this.credentialFlowStore.identityOptions[0]);
        this.challengeType = this.credentialFlowStore.identityOptions[0].optionType;
        this.hasMultipleProofingOptions = this.credentialFlowStore.identityOptions.length > 1;
      }
    });

    this.zipCode = this.zipCodeProp;
    this.dateOfBirth = this.dateOfBirthProp;
    this.showSkipMfaEmailVerifyStep = false;
  }

  currentIndex = 0;

  get steps () {
    return [
      { allowed: true, step: HsabClaimAccountStep.Verification },
      { allowed: !this.showDataEntryOption, step: HsabClaimAccountStep.VerifyIdentityProofingChallenge },
      { allowed: true, step: HsabClaimAccountStep.EditAccountInfo },
      { allowed: true, step: HsabClaimAccountStep.VerifyMfaEmail }
    ];
  }

  get currentStep (): HsabClaimAccountStep {
    return this.steps[this.currentIndex].step;
  }

  stepComplete (): void {
    const finalStep = this.steps.filter(x => x.allowed).map(x => x.step).sort((a, b) => b - a)[0];

    if (finalStep === this.currentStep) {
      this.$router.push(mergeReturnUrl(this.$route, this.routeToClaimAccountVerify));
    }

    const indexOfNextStep = this.steps.findIndex((el, index) => el.allowed && index > this.currentIndex);
    if (indexOfNextStep !== -1) {
      this.currentIndex = indexOfNextStep;
    }
  }

  get isNextButtonDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  get showLoadingSpinner () {
    return !this.credentialFlowStore.isIdentityOptionsLoaded;
  }

  get showVerification () {
    return this.currentStep === HsabClaimAccountStep.Verification;
  }

  get showVerifyIdentityProofingChallenge () {
    return this.currentStep === HsabClaimAccountStep.VerifyIdentityProofingChallenge;
  }

  get showVerifyMfaEmailStep () {
    return this.currentStep === HsabClaimAccountStep.VerifyMfaEmail;
  }

  get showEditAccountInfo () {
    return this.currentStep === HsabClaimAccountStep.EditAccountInfo;
  }

  get showProofingOptions (): boolean {
    return this.hasProofingOptions;
  }

  get showDataEntryOption (): boolean {
    return this.credentialFlowStore.selectedIdentityOption &&
        this.credentialFlowStore.selectedIdentityOption.optionType === IdentityProofingOptionType.DataEntry;
  }

  get friendlyProofingOptionType (): string {
    switch (this.credentialFlowStore.selectedIdentityOption.optionType) {
      case IdentityProofingOptionType.Email:
        return "email address";
      case IdentityProofingOptionType.Sms:
        return "mobile number";
      case IdentityProofingOptionType.Voice:
        return "phone number";
      default:
        return "none";
    }
  }

  get showZipInput (): boolean {
    return !this.zipCodeProp || this.zipCodeProp.length < 0;
  }

  get showDobInput (): boolean {
    return !this.dateOfBirthProp || this.dateOfBirthProp.length < 0;
  }

  get showAdditionalInformationNeededMessage (): boolean {
    return !this.showZipInput || !this.showDobInput;
  }

  notifyUserToVerifyIdentityChallenge () {
    let optionTypeMessage = "";
    switch (this.challengeType) {
      case IdentityProofingOptionType.Email:
        optionTypeMessage = "check your email";
        break;
      case IdentityProofingOptionType.Sms:
        optionTypeMessage = "check your sms message";
        break;
      case IdentityProofingOptionType.Voice:
        optionTypeMessage = "wait for a voice call";
        break;
      default:
        break;
    }
    this.notifierStore.setSuccess(
        `Thank you for entering your information. Please ${optionTypeMessage} to continue the process.`);
  }

  @Watch("newHomePhone")
  onHomePhoneChanged () {
    this.credentialFlowStore.setPhone(this.newHomePhone);
  }

  @Watch("newMobilePhone")
  onMobilePhoneChanged () {
    this.credentialFlowStore.setMobilePhone(this.newMobilePhone);
  }

  @Watch("newEmail")
  onEmailChanged () {
    this.credentialFlowStore.setEmail(this.newEmail);
  }

  onIdentityProofingChallengeSubmit (completeStep = true) {
    this.isSubmitting = true;
    this.verificationCode = "";
    identityProofingChallenge({
      username: this.credentialFlowStore.credentialFlowUsername,
      identityProofingOptionType: this.challengeType
    }).then(resp => {
      if (resp.data.success) {
        if (completeStep) {
          this.stepComplete();
        }

        this.notifyUserToVerifyIdentityChallenge();
      }
    }).catch(err => {
      const errMsg = this.getErrorMessage(err);
      this.notifierStore.setDanger(errMsg);
    }).finally(() => {
      this.isSubmitting = false;
    });
  }

  onIdentityProofingVerifySubmit () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.isSubmitting = true;

      identityProofingVerify({
        username: this.credentialFlowStore.credentialFlowUsername,
        verificationCode: this.verificationCode,
        identityProofingOptionType: this.challengeType,
        isMobileApp: isMobileApp()
      }).then(resp => {
            const data = resp.data;
            this.credentialFlowStore.setBendUserId(data.bendUserId);
            this.credentialFlowStore.setSignature(data.signature);
            this.mapContactModel(data.contactInfo);
            this.stepComplete();

            if (this.challengeType === IdentityProofingOptionType.Email) {
              this.credentialFlowStore.setIsEmailVerified({ email: this.newEmail, isVerified: true });
            }
          }
      ).catch(err => {
        const errMsg = this.getErrorMessage(err);
        this.notifierStore.setDanger(errMsg);
      }).finally(() => {
        this.isSubmitting = false;
      });
    });
  }

  onDataIdentityProofingVerifySubmit () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;

      const request: IdentityProofDataVerifyRequest = {
        username: this.credentialFlowStore.credentialFlowUsername,
        data: {
          ssn: this.ssn,
          dateOfBirth: moment(this.dateOfBirth).format("YYYY-MM-DD"),
          zip: this.zipCode
        },
        isMobileApp: isMobileApp()
      };

      identityProofingDataVerify(request)
          .then(resp => {
                const data = resp.data;
                return verifyHsabAccount({
                  bendUserId: data.bendUserId,
                  verificationType: this.verifyAccountWithAccountNumber
                      ? AccountVerificationType.accountNumber
                      : AccountVerificationType.cardLastFourDigits,
                  value: this.verifyAccountWithAccountNumber
                      ? this.accountNumber
                      : this.cardLastFourDigits,
                  signature: data.signature
                })
                    .then(accountVerifyResponse => {
                      this.credentialFlowStore.setBendUserId(data.bendUserId);
                      this.credentialFlowStore.setSignature(accountVerifyResponse.data.signature);
                      this.mapContactModel(data.contactInfo);
                      this.stepComplete();
                    });
              }
          ).catch(err => {
        const errMsg = this.getErrorMessage(err);
        this.notifierStore.setDanger(errMsg);
      }).finally(() => {
        this.isSubmitting = false;
      });
    });
  }

  onMfaEmailChallengeSubmit (completeStep = true) {
    if (!this.credentialFlowStore.isEmailVerified[this.newEmail]) {
      return mfaEmailChallenge({ bendUserId: this.credentialFlowStore.bendUserId, email: this.newEmail })
          .then(resp => {
            if (resp.data.success) {
              this.verificationCode = "";
              this.challengeType = IdentityProofingOptionType.Email;
              // resend code
              this.showSkipMfaEmailVerifyStep = !completeStep;
              if (completeStep) {
                this.stepComplete();
              }
            }
          });
    } else {
      this.$router.push(mergeReturnUrl(this.$route, this.routeToClaimAccountVerify));
      return;
    }
  }

  onMfaEmailVerifySubmit () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }
      this.isSubmitting = true;

      mfaEmailVerify({
        bendUserId: this.credentialFlowStore.bendUserId,
        verificationCode: this.verificationCode,
        identityProofingOptionType: this.credentialFlowStore.selectedIdentityOption.optionType,
        isMobileApp: isMobileApp()
      }).then(resp => {
            const data = resp.data;
            this.credentialFlowStore.setBendUserId(data.bendUserId);
            this.credentialFlowStore.setSignature(data.signature);
            this.mapContactModel(data.contactInfo);
            this.stepComplete();
            this.credentialFlowStore.setIsEmailVerified({ email: this.newEmail, isVerified: true });
          }
      ).catch(err => {
        const errMsg = this.getErrorMessage(err);
        this.notifierStore.setDanger(errMsg);
      }).finally(() => {
        this.isSubmitting = false;
      });
    });
  }

  onOptionSelected (optionType) {
    const option = _.find(this.credentialFlowStore.identityOptions, [ "optionType", optionType ]);
    this.challengeType = option.optionType;
    this.credentialFlowStore.setSelectedIdentityOption(option);
  }

  goToVerificationStep () {
    this.currentIndex = HsabClaimAccountStep.Verification;
  }

  continueWithoutMfaEmailVerification () {
    this.stepComplete();
  }

  getErrorMessage (err: any) {
    return err && err.response && err.response.data && err.response.data.errorMessage
        ? err.response.data.errorMessage
        : "Something went wrong.";
  }

  mapContactModel (info) {
    this.firstName = info.firstName;
    this.lastName = info.lastName;
    this.oldHomePhone = info.phoneNumber;
    this.newHomePhone = info.phoneNumber;
    this.oldMobilePhone = info.mobilePhoneNumber;
    this.newMobilePhone = info.mobilePhoneNumber;
    this.oldEmail = info.email;
    this.newEmail = info.email;
    this.zipCode = info.zip;
  }

  toggleInputMask (elementId: string) {
    const element = document.getElementById(elementId);

    if (element.getAttribute("type") === "password") {
      element.setAttribute("type", "text");
    } else {
      element.setAttribute("type", "password");
    }
  }

  onAccountVerificationTypeChange (value) {
    this.verifyAccountWithAccountNumber = value;
    this.accountNumber = "";
    this.cardLastFourDigits = "";
  }
}
